import { Box, Stack, Typography } from '@mui/material';

export const BulletItem = ({
  title,
  leftContent,
  rightContent,
}: {
  title?: string;
  leftContent: React.ReactNode;
  rightContent?: React.ReactNode;
}) => {
  return (
    <Stack
      direction='row'
      sx={{
        width: '100%',
        gap: '100px',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        sx={{
          gap: '24px',
        }}
      >
        {title && (
          <Typography sx={{ width: '540px' }} variant='body1'>
            {title}
          </Typography>
        )}
        <Box
          sx={{
            width: '440px',
          }}
        >
          {leftContent}
        </Box>
      </Stack>
      <Box
        sx={{
          width: '50%',
        }}
      >
        {rightContent}
      </Box>
    </Stack>
  );
};
